<template>
    <div class="seven_content">
        <div class="seventoos">
            <div class="seventoos_top">
                <div></div>
                <p>媒体报道</p>
            </div>
            <div class="midtext" style="white-space: nowrap;">MEDIA COVERAGE</div>
            <div class="showLisecv">
                <div><img style="width:138px;height:49px" src="./../../images/mtfp1.png" alt="凤凰网" /></div>
                <div><img style="width:115px;height:66px" src="./../../images/mtfp2.png" alt="中证网" /></div>
                <div><img style="width:104px;height:52px" src="./../../images/mtfp3.png" alt="搜狐" /></div>
                <div><img style="width:159px;height:49px" src="./../../images/mtfp4.png" alt="中国新闻网" /></div>
                <div><img style="width:158px;height:52px" src="./../../images/mtfp5.png" alt="中国网科学中国" /></div>
                <div><img style="width:120px;height:32px" src="./../../images/mtfp6.png" alt="云财经" /></div>
                <div><img style="width:170px;height:32px" src="./../../images/mtfp7.png" alt="金色财经" /></div>
                <div><img style="width:116px;height:51px" src="./../../images/mtfp8.png" alt="创业网" /></div>
                <div><img style="width:152px;height:69px" src="./../../images/mtfp9.png" alt="新浪网" /></div>
                <div><img style="width:115px;height:66px" src="./../../images/mtfp10.png" alt="中证网" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'firseven',
        data(){
            return {
                
            }
        },
        methods:{

        }
    }
</script>

<style scoped lang="less">
    .seven_content{
        min-height:533px;
        background:rgba(250,252,254,1);
        .seventoos{
            width: 1334px;
            min-height: 533px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            .midtext{
                margin-top:50px;
                width:213px;
                height:28px;
                font-size:20px;
                font-weight:400;
                color:rgba(4,4,4,1);
                line-height:28px;
                letter-spacing:2px;
                margin-bottom:50px;
                margin-left: -30px;
            }
            .seventoos_top{
                padding-top:80px;
                height:55px;
                line-height:55px;
                display:flex;
                margin-bottom:14px;
                p{
                    height:42px;
                    font-size:30px;
                    font-weight:800;
                    color:rgba(4,4,4,1);
                    letter-spacing:3px;
                    margin-left: -93px;
                }
                div{
                    width:55px;
                    height:55px;
                    background:rgba(255,216,0,1);
                    border-radius:50%;
                }
            }
            .showLisecv{
                /*display:flex;*/
                /*justify-content: flex-start;*/
                /*flex-wrap: wrap;*/
                width: 100%;
                overflow: hidden;
                white-space: normal;
                div{
                    display: inline-block;
                    width:248px;
                    height:103px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
                    margin-right:18px;
                    margin-bottom:20px;
                    text-align:center;
                    vertical-align: middle;
                    line-height: 103px;
                    img{
                        vertical-align: middle;
                    }
                }
            }
        }
    }
</style>